import { z } from 'zod';

// ---------------------------------------------------------------------------
// ApiError — wire shape for all HTTP error responses from @wandero/api
// Matches the `ApiError` class in `api/src/postgrest/errors.ts`
// Shape: { error: { code, message, details? } }
// ---------------------------------------------------------------------------

export const ApiErrorCodeSchema = z.enum([
  'BAD_REQUEST',
  'NOT_FOUND',
  'UNAUTHORIZED',
  'UPSTREAM',
  'INTERNAL',
]);
export type ApiErrorCode = z.infer<typeof ApiErrorCodeSchema>;

export const ApiErrorSchema = z.object({
  error: z.object({
    code: ApiErrorCodeSchema,
    message: z.string(),
    details: z.unknown().optional(),
  }),
});
export type ApiErrorResponse = z.infer<typeof ApiErrorSchema>;

// ---------------------------------------------------------------------------
// Pagination — standard envelope for paginated list responses
// ---------------------------------------------------------------------------

export const PaginationSchema = z.object({
  page: z.number().int().positive(),
  perPage: z.number().int().positive(),
  total: z.number().int().nonnegative(),
});
export type Pagination = z.infer<typeof PaginationSchema>;

// ---------------------------------------------------------------------------
// LangCountryQuerySchema — shared query params used by most endpoints
// e.g. ?lang=pl&country=PL
// ---------------------------------------------------------------------------

export const LangCountryQuerySchema = z.object({
  lang: z.string().min(2).max(10),
  country: z.string().min(2).max(10),
});
export type LangCountryQuery = z.infer<typeof LangCountryQuerySchema>;
